<template>
  <v-container fluid>
    <router-link class="subtitle-1 grey-navy--text font-weight-bold" style="text-decoration: none" :to="backLink">
      <v-icon small class="pb-1"> keyboard_backspace </v-icon> Dashboard
    </router-link>
    <v-row v-if="loading">
      <v-col cols="12" align="center" justify="center">
        <v-row align="center" justify="center">
          <v-text-field color="success" loading disabled></v-text-field>
        </v-row>
      </v-col>
    </v-row>
    <v-row v-if="!loading">
      <v-col cols="6">
        <client-information :userId="userId"></client-information>
        <client-goals :userId="userId" :coachId="coachId"></client-goals>
        <client-subscription :userId="userId"></client-subscription>
        <client-medical-assessment :userId="userId"></client-medical-assessment>
      </v-col>
      <v-col cols="6" class="py-0 mt-9">
        <v-card>
          <client-action-bar
            :userId="userId"
            :coachId="coachId"
            :hubspotTicketLink="hubspotTicketLink"
            v-on:problem="alertProblem"
          >
          </client-action-bar>
        </v-card>
        <client-user-program :userId="userId"></client-user-program>
        <manage-assessment-block :userId="userId" />
        <block-history :userId="userId" :allowCreate="true"></block-history>
        <nutrition-block-history :userId="userId"></nutrition-block-history>
        <client-progress :userId="userId" :coachId="coachId" :showAll="false"></client-progress>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { CLIENT_QUERY } from "../../constants/graphql/client/client";
import ClientInformation from "./blocks/ClientInformation";
import ClientGoals from "./blocks/ClientGoals";
import ClientSubscription from "./blocks/ClientSubscription";
import ClientActionBar from "./blocks/ClientActionBar";
import ClientProgress from "./blocks/ClientProgress";
import ClientMedicalAssessment from "./blocks/ClientMedicalAssessment";
import BlockHistory from "@/components/workout_blocks/BlockHistory";
import NutritionBlockHistory from "@/components/workout_blocks/NutritionBlockHistory";
import ManageAssessmentBlock from "@/components/client/blocks/progress/assessments/ManageAssessmentBlock";
import ClientUserProgram from "./blocks/ClientUserProgram";

export default {
  name: "ClientProfile",
  props: ["userId", "coachId"],
  components: {
    ClientInformation,
    ClientGoals,
    ClientSubscription,
    ClientActionBar,
    ClientProgress,
    ClientMedicalAssessment,
    BlockHistory,
    NutritionBlockHistory,
    ManageAssessmentBlock,
    ClientUserProgram,
  },
  data() {
    return {
      loading: true,
      backendTicketLink: "",
      hubspotTicketLink: "",
      client: {
        name: "",
        shorthandName: "",
        profilePicture: null,
      },
      problemConnecting: false,
      problemConnectingText:
        "\nYou may be experiencing some internet connectivity issues. Please refresh your page and try again." +
        "\nReach out to tech support if you continue to have issues as your changes will not be saved.",
    };
  },
  computed: {
    backLink() {
      return `/dashboard/${this.coachId}/clients/daily`;
    },
  },
  methods: {
    alertProblem() {
      alert(`Something went wrong. \n\n${this.problemConnectingText}`);
    },
  },
  apollo: {
    client: {
      query: CLIENT_QUERY,
      variables() {
        return {
          userId: this.userId,
        };
      },
      fetchPolicy: "cache-and-network",
      result(response) {
        if (response.data) {
          let client = response.data.client;
          if (client?.hubspotPortalId && client?.hubspotTicketId)
            this.hubspotTicketLink = `https://app.hubspot.com/contacts/${client.hubspotPortalId}/ticket/${client.hubspotTicketId}/`;

          if (client.lastName[client.lastName.length - 1] == "s")
            this.client.name = `${client.firstName} ${client.lastName}'`;
          else this.client.name = `${client.firstName} ${client.lastName}'s`;
          this.client.shorthandName = `${client.firstName[0]} ${client.lastName[0]}`;
          this.client.profilePicture = client.profilePicture;

          this.loading = false;
        }
      },
    },
  },
};
</script>

<style scoped>
.profile {
  display: flex;
}
</style>
